import { render, staticRenderFns } from "./viewHistory.vue?vue&type=template&id=404c7232&scoped=true"
import script from "./viewHistory.vue?vue&type=script&lang=js"
export * from "./viewHistory.vue?vue&type=script&lang=js"
import style0 from "./viewHistory.vue?vue&type=style&index=0&id=404c7232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c7232",
  null
  
)

export default component.exports